import { Flex, Text } from "@chakra-ui/react";
import { type ChainFullId, ChainIds } from "@umami/chains";
import { useGetNetworkByFullId } from "@umami/state";
import capitalize from "lodash/capitalize";
import { type FC, type HTMLAttributes } from "react";

import { ChainIcon } from "@/components/Token/ChainIcon";
import { useColor } from "@/styles/useColor";

type ChainIconWithNameProp = FC<
  {
    chainId: ChainFullId;
    name?: string;
  } & HTMLAttributes<HTMLDivElement>
>;

export const ChainIconWithName: ChainIconWithNameProp = ({ chainId, name, role }) => {
  const color = useColor();
  const network = useGetNetworkByFullId()(chainId);
  const chainName =
    name ?? (network.chain === ChainIds.TEZOS ? capitalize(ChainIds.TEZOS) : network.name);

  return (
    <Flex alignItems="center" display="inline-flex" aria-label={chainName} role={role}>
      <Flex alignItems="center" flex="0 0 auto" marginRight="12px">
        <ChainIcon chainId={network.chain} />
      </Flex>

      <Flex alignItems="center" flexDirection="column" flex="1 1 auto" gap="4px" marginRight="12px">
        <Flex alignItems="center" gap="6px">
          <Text color={color("black")} fontWeight="600" data-testid="token-symbol" size="md">
            {chainName}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
};
